export const OPACITY_FADE_TRANSITION = {
  enterActiveClass: 'transition-opacity duration-200 ease-out',
  leaveActiveClass: 'transition-opacity duration-150 ease-in',
  enterFromClass: 'opacity-0',
  enterToClass: 'opacity-100',
  leaveFromClass: 'opacity-100',
  leaveToClass: 'opacity-0',
} as const;
